import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  generateSellarMetaData,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  BusinessJoinRequestType,
  BusinessMetadataType,
  BusinessJoinResponseType,
} from "@sellar-io/api-v2/types";

export const useBusinessJoin = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (request: {
      data: { id: number } & BusinessJoinRequestType;
      sellarMetadata?: BusinessMetadataType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses/${request.data.id}/join`,
        data: request.data,
        sellarMetadata: request.sellarMetadata
          ? generateSellarMetaData(request.sellarMetadata)
          : undefined,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as BusinessJoinResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
